module.exports = __webpack_public_path__ + "static/media/40-11.f0ebac30.mp3";